import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Modal, ModalHandle, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { BsTrash } from '@react-icons/all-files/bs/BsTrash';
import { Button, ButtonGroup } from 'reactstrap';
import { ClientsStore } from '../Clients/ClientsStore';
import { AppStore } from '../Core/AppStore';

export interface IClientRowProps {
    readonly client: Mri.Web.Portal.Controllers.Clients.ClientModel;
}

@autoinject
@observer
export class ClientRow extends React.Component<IClientRowProps> {
    public render() {
        return (
            <tr>
                <td className="ps-2">{this.props.client.clientId}</td>
                <td>{this.props.client.allowedScopes.join(', ')}</td>
                <td>
                    <ButtonGroup className="my-1">
                        <Button className="btn-danger" onClick={this.delete} />
                        <BsTrash />
                    </ButtonGroup>
                </td>
                <Modal
                    className="modal-sm"
                    title="Confirm Deletion"
                    modalHandle={this.modalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div className="text-center">{'Delete ' + this.props.client.clientId + '?'}</div>
                </Modal>
            </tr>
        );
    }

    @bind
    private async delete(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        if (await this.modalHandle.confirm()) {
            const task = this.tasksStore.startSessionTask(`Delete Client ${this.props.client.clientId}`);

            try {
                await this.clientsStore.removeClientAsync(this.props.client);
                task.complete();
            } catch (e: any) {
                console.error('Error caught trying to delete ' + this.props.client.clientId);
                task.error(e);
            }
        }
    }

    @observable
    private modalHandle = new ModalHandle();
    @inject
    private clientsStore!: ClientsStore;
    @inject
    private tasksStore!: TasksStore;
}
